import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { OctPopoverProps } from "./type";

const OctPopover = ({
	title,
	children,
	overlayProps,
	buttonProps,
	triggerContent,
	popoverProps,
}: OctPopoverProps) => {
	const popover = (
		<Popover {...popoverProps}>
			{title && <Popover.Header as="h3">{title}</Popover.Header>}
			<Popover.Body className="spaces p-12">{children}</Popover.Body>
		</Popover>
	);

	return (
		<OverlayTrigger trigger="click" overlay={popover} {...overlayProps}>
			{triggerContent ? (
				<div>{triggerContent}</div>
			) : (
				<Button {...buttonProps}>{buttonProps?.children}</Button>
			)}
		</OverlayTrigger>
	);
};

export default OctPopover;
